const toPersonalDetails = (raw, email)=>{
    var ref, ref1;
    return {
        dateOfBirth: (ref = raw === null || raw === void 0 ? void 0 : raw.dateOfBirth) !== null && ref !== void 0 ? ref : '',
        phone: (ref1 = raw === null || raw === void 0 ? void 0 : raw.phone) !== null && ref1 !== void 0 ? ref1 : '',
        email: email !== null && email !== void 0 ? email : ''
    };
};
const toBillingAddress = (raw)=>{
    var ref, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    return {
        additionalStreetInfo: (ref = raw === null || raw === void 0 ? void 0 : raw.additionalStreetInfo) !== null && ref !== void 0 ? ref : '',
        additionalAddressInfo: (ref2 = raw === null || raw === void 0 ? void 0 : raw.additionalAddressInfo) !== null && ref2 !== void 0 ? ref2 : '',
        city: (ref3 = raw === null || raw === void 0 ? void 0 : raw.city) !== null && ref3 !== void 0 ? ref3 : '',
        company: (ref4 = raw === null || raw === void 0 ? void 0 : raw.company) !== null && ref4 !== void 0 ? ref4 : '',
        country: (ref5 = raw === null || raw === void 0 ? void 0 : raw.country) !== null && ref5 !== void 0 ? ref5 : '',
        postalCode: (ref6 = raw === null || raw === void 0 ? void 0 : raw.postalCode) !== null && ref6 !== void 0 ? ref6 : '',
        prefix: (ref7 = raw === null || raw === void 0 ? void 0 : raw.prefix) !== null && ref7 !== void 0 ? ref7 : '',
        region: (ref8 = raw === null || raw === void 0 ? void 0 : raw.region) !== null && ref8 !== void 0 ? ref8 : '',
        streetName: (ref9 = raw === null || raw === void 0 ? void 0 : raw.streetName) !== null && ref9 !== void 0 ? ref9 : '',
        streetNumber: (ref10 = raw === null || raw === void 0 ? void 0 : raw.streetNumber) !== null && ref10 !== void 0 ? ref10 : '',
        firstName: (ref11 = raw === null || raw === void 0 ? void 0 : raw.firstName) !== null && ref11 !== void 0 ? ref11 : '',
        lastName: (ref12 = raw === null || raw === void 0 ? void 0 : raw.lastName) !== null && ref12 !== void 0 ? ref12 : '',
        middleName: (ref13 = raw === null || raw === void 0 ? void 0 : raw.middleName) !== null && ref13 !== void 0 ? ref13 : '',
        salutation: (ref14 = raw === null || raw === void 0 ? void 0 : raw.salutation) !== null && ref14 !== void 0 ? ref14 : ''
    };
};

export { toBillingAddress, toPersonalDetails };
//# sourceMappingURL=user-details-to-shipping-summary-mapper.js.map
